import React, { useEffect, useState, useRef } from "react";
import map from "./images/fukusato.svg";
import header from "./images/header.svg";
import aizu_area from "./images/aizu_area.svg";
import fukushima_area from "./images/fukushima_area.svg";
import tsuchiyu_area from "./images/tsuchiyu_bandai_area.svg";
import "./App.css";
import Data from "./data/fukusato.json";
import styled, { css } from "styled-components";

const MapBase = ({ data: base_data, index: base_index }) => {
  if (base_data)
    return (
      <div
        className="map-child-base-ani"
        key={base_data.serial_num}
        onClick={() => {
          window.location.href = base_data.href;
        }}
        style={{
          top: base_data.position.y + "%",
          left: base_data.position.x + "%",
        }}
      >
        <div className={"map-child-base-" + base_data.serial_num}>
          <p className="title">{base_data.name}</p>
          <p className="detail">{base_data.detail}</p>
        </div>
      </div>
    );
  else return <></>;
};

const MapCommunity = ({
  data: community_data,
  index: community_index,
  serial_num: serial_num,
  show: show,
}) => {
  if (community_data)
    return (
      <a
        className="map-child-community-ani"
        key={community_data.serial_num}
        href={community_data.href}
        show={show}
        style={
          community_data.position.axis == 0
            ? {
                top: 0,
                left: community_data.position.value * 33 + "%",
              }
            : {
                bottom: 0,
                left: community_data.position.value * 33 + "%",
              }
        }
      >
        <div className={"map-child-community-" + serial_num}>
          <p className="title">{community_data.name}</p>
          <p className="detail">{community_data.detail}</p>
        </div>
      </a>
    );
  else return <></>;
};

const MapArea = ({
  changeZoom,
  changeRef,
  data: area_data,
  index: area_index,
  zoom: zoom,
}) => {
  if (area_data) {
    let area_icon = aizu_area;
    let icon_size = "100";
    if (area_data.id == "aizu") {
      area_icon = aizu_area;
      icon_size = "100";
    } else if (area_data.id == "tsuchiyu") {
      area_icon = tsuchiyu_area;
      icon_size = "65";
    } else if (area_data.id == "fukushima") {
      area_icon = fukushima_area;
      icon_size = "100";
    }
    return (
      <>
        <button
          id={area_data.id}
          key={area_data.serial_num}
          ref={(el) => {
            if (el === null) return;
            changeRef([area_data.id], {
              x: el.getBoundingClientRect().x,
              y: el.getBoundingClientRect().y,
              width: el.getBoundingClientRect().width,
              height: el.getBoundingClientRect().height,
            });
          }}
          onClick={() => {
            changeZoom(area_data.id);
          }}
          style={{
            top: area_data.button.position.y + "%",
            left: area_data.button.position.x + "%",
            borderRadius: area_data.button.size.r + "px",
            height: area_data.button.size.h + "%",
            width: area_data.button.size.w + "%",
          }}
        />
        <div className="map-child">
          <div
            className="map-child-area"
            show={zoom == "all" ? "true" : "false"}
          >
            <div
              className="map-child-area-ani"
              key={area_data.serial_num}
              style={{
                top: area_data.flag.position.y + "%",
                left: area_data.flag.position.x + "%",
              }}
            >
              <div className={"map-child-area-" + area_data.serial_num}>
                <img
                  src={area_icon}
                  alt=""
                  style={{ width: icon_size + "%" }}
                ></img>
              </div>
            </div>
          </div>
          {area_data.children.map((base_data, base_index) => {
            return (
              <React.Fragment key={base_index}>
                <div
                  className="map-child-base"
                  show={zoom === area_data.id ? "true" : "false"}
                >
                  <MapBase data={base_data} index={base_data.serial_num} />
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

const Map = styled.div`
  ${({ zoom, pos, width, height }) =>
    zoom === "all"
      ? `transform: translate(-50%, -50%) scale(1.2); left:50vw; top:70vh;`
      : `transform: translate(-50%, -50%) scale(2); 
      left: calc(150vw - ${pos.x * 2 + pos.width}px); 
      top: calc(150vh - ${pos.y + pos.height}px);
`}
`;

const App = () => {
  const refMain = useRef(null);
  const [ref, setRef] = useState({});
  const [zoom, setZoom] = useState("all");
  const [pos, setPos] = useState({ x: 0, y: 0, width: 0, height: 0 });

  useEffect(() => {
    if (zoom == "all") setPos({ x: 0, y: 0, width: 0, height: 0 });
    else if (ref[zoom])
      setPos({
        x: ref[zoom].x,
        y: ref[zoom].y,
        width: ref[zoom].width,
        height: ref[zoom].height,
      });
  }, [zoom]);

  const changeZoom = (value) => {
    setZoom("all");
    setZoom(value);
  };

  const changeRef = (key, value) => {
    if (!ref[key]) setRef({ ...ref, [key]: value });
  };

  return (
    <div className="main">
      <header className="header">
        <img src={header} alt="" width={300} />
      </header>
      <div className="map-child-community">
        {Data.data.map((area_data, index) => {
          return area_data.children.map((base_data, base_index) => {
            return base_data.children.map((community_data, community_index) => (
              <MapCommunity
                show={zoom === area_data.id ? "true" : "false"}
                key={community_data.serial_num}
                data={community_data}
                index={community_index}
                serial_num={community_data.serial_num}
              />
            ));
          });
        })}
      </div>
      <Map
        id="Fukusato-map"
        width={
          refMain.current ? refMain.current.getBoundingClientRect().width : null
        }
        height={
          refMain.current
            ? refMain.current.getBoundingClientRect().height
            : null
        }
        ref={refMain}
        zoom={zoom}
        pos={pos}
      >
        <img id="Fukusato" src={map} useMap="#Map" alt="" />
        <div id="Map-base">
          <div id="Map">
            <button
              onClick={() => {
                changeZoom("all");
              }}
              id="Map-click"
            ></button>
            {Data.data.map((value, index) => (
              <MapArea
                changeZoom={changeZoom}
                changeRef={changeRef}
                zoom={zoom}
                data={value}
                index={index}
                key={value.serial_num}
              />
            ))}
          </div>
        </div>
      </Map>
    </div>
  );
};

export default App;
